import { render } from "./Btn.vue?vue&type=template&id=68e9a8c0&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"

import "./Btn.vue?vue&type=style&index=0&id=68e9a8c0&lang=sass&scoped=true"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e9a8c0"]])

export default __exports__